import { FieldWrapper } from '@/components/Form/FieldWrapper';
import Select, { GroupBase, Props } from 'react-select';

export type Option<ValueT = string> = {
  label: string;
  value: ValueT;
};

type SelectFieldProps<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
> = Props<Option, IsMulti, Group> & {
  label?: React.ReactNode;
};

export const SelectField = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  label,
  ...props
}: SelectFieldProps<Option, IsMulti, Group>) => {
  return (
    <FieldWrapper label={label}>
      <Select {...props} />
    </FieldWrapper>
  );
};

export const SmallSelectField = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  transparent,
  ...props
}: SelectFieldProps<Option, IsMulti, Group> & { transparent?: true }) => {
  const transparentStyle = transparent && {
    backgroundColor: 'transparent',
    border: 'none',
    boxShadow: 'none',
  };

  return (
    <SelectField
      {...props}
      className="text-sm"
      styles={{
        control: (provided) => ({
          ...provided,
          minHeight: '25px',
          height: '25px',
          ...transparentStyle,
        }),
        valueContainer: (provided) => ({
          ...provided,
          minHeight: '25px',
          height: '25px',
          lineHeight: '25px',
          padding: '0px',
          paddingLeft: '6px',
        }),
        placeholder: (provided) => ({
          ...provided,
          margin: 0,
        }),
        input: (provided) => ({
          ...provided,
          margin: '0px',
          height: '25px',
        }),
        indicatorSeparator: () => ({
          display: 'none',
        }),
        indicatorsContainer: (provided) => ({
          ...provided,
          height: '25px',
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          height: '25px',
          padding: 2,
        }),
        option: (provided) => ({
          ...provided,
          height: '25px',
          lineHeight: '25px',
          padding: '0 12px',
        }),
        menu: (provided) => ({
          ...provided,
          width: 'max-content',
          right: 0,
        }),
      }}
    />
  );
};
